<template>

  <div>
    <edit-pane ref="step3"
      @save="onSave" @cancel="onCancel" @edit="onEdit"  />


    <el-form ref='prgStep3' v-model='doc' label-width='110px'>

      <el-row v-if="this.doc">   <!-- Top level of two column display -->

        <el-col :span="8">
          <select-users v-model="step.updated_by" :disabled="dis" />
        </el-col>

        <el-col :span="8">
          <select-action-status  v-model="step.status"  :disabled="dis" />
        </el-col>

        <el-col :span="8">
          <select-priority  v-model="step.priority" :disabled="dis" />
        </el-col>
<!--
        <el-col :span="24">

        <el-row :gutter="gutter">
            <el-col :span="8" :offset="4">
              <span>Person In Charge</span>
            </el-col>
            <el-col  :span="6" :offset="2">
              <span>Cheque Received</span>
            </el-col>
         </el-row>

         <el-row>
          <el-col :span="" :offset="4">
          </el-col>

          <el-col :span="6" :offset="4">
            <el-form-item label-width="0px" required>
              <el-switch active-text="Yes" inactive-text="No" active-color="#5ccdcd" inactive-color="#cd5c5c" v-model="doc.chequeDone" :disabled="dis"></el-switch>
            </el-form-item>
          </el-col>
-->
        </el-row>

        <el-row>
          <h4>Approvals</h4>
        </el-row>

      <el-row :gutter="gutter">
        <el-col :span="8" align="center">
          <span>Submitted</span>
        </el-col>
        <el-col  :span="8" align="center">
          <span>Completed</span>
        </el-col>
        <el-col  :span="8" align="center">
          <span>Approved</span>
        </el-col>
      </el-row>

      <el-row v-for="(item, index) in doc.approvals" :key="index">

        <el-col :span="8">
          <el-form-item :label="item.approver">
            <el-date-picker value-format="yyyy-MM-dd" :id="'sub' + index" :format="dateFormat"
            v-model="item.submittedOn"
            placeholder="Submitted"
            :disabled="dis" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item>
            <el-date-picker value-format="yyyy-MM-dd" :id="'comp' + index" :format="dateFormat"
            v-model="item.completedOn"
            placeholder="Completed"
            @change="completedDate(item.completedOn, item.completed)"
            :disabled="dis" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item>
            <el-switch :id="'compYN' + index" active-text="Yes" inactive-text="No"
            :width="58" active-color="#5ccdcd" inactive-color="#cd5c5c"
            v-model="item.completed"
            @change="completedToggle(item.completedOn, item.completed)"
            :disabled="dis" />
          </el-form-item>
        </el-col>
      </el-row>

    </el-col>
<!--
    <!-- Second column --
    <el-col :span="24">
        <h4>Required Documents</h4><br />

        <el-row :gutter="gutter">
          <el-col :span="12">
            <b>Company Docs</b>
          <el-checkbox-group v-model="doc.companyDocs" :disabled="dis">
            <el-checkbox style="padding-left: 1em;" label="Company Profile" v-model="doc.companyDocs[0]"></el-checkbox>
          </el-checkbox-group>
        </el-col>

        <el-col :span="12">
          <b>Letters</b>
          <el-checkbox-group v-model="doc.letters" :disabled="dis">
            <el-checkbox style="padding-left: 1em;" label="Offer Letter" v-model="doc.letters[0]"></el-checkbox>
            <el-checkbox label="Power of Attorney" v-model="doc.letters[1]"></el-checkbox>
            <el-checkbox label="LOO"  v-model="doc.letters[2]"></el-checkbox>
          </el-checkbox-group>
        </el-col>
        </el-row>

        <el-row :gutter="gutter">
        <el-col :span="12">
          <b>Tax Docs</b>
          <el-checkbox-group v-model="doc.taxDocs" :disabled="dis">
            <el-checkbox style="padding-left: 1em;" label="Quit Rent Tax" v-model="doc.taxDocs[0]"></el-checkbox>
            <el-checkbox label="Assessment" v-model="doc.taxDocs[1]"></el-checkbox>
            <el-checkbox label="I.R. Letter" v-model="doc.taxDocs[2]"></el-checkbox>
          </el-checkbox-group>
        </el-col>

        <el-col :span="12">
          <b>Structure / Tower Docs</b>
          <el-checkbox-group v-model="doc.towerDocs" :disabled="dis">
            <el-checkbox style="padding-left: 1em;" label="Insurance" v-model="doc.towerDocs[0]"></el-checkbox>
            <el-checkbox label="Tower Calculation" v-model="doc.towerDocs[1]"></el-checkbox>
            <el-checkbox label="Land Title" v-model="doc.towerDocs[2]"></el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>
        </el-col>
    </el-col>
-->
    </el-row>

      <hr>

      <section>

        <h5>General Remarks</h5>
        <div>
          <html-input v-model="step.remarks" :disabled="dis"  />
        </div>

        <hr v-if="step.remarks" />

      </section>

      <el-row>
        <h3>Review &amp; Approval</h3>
      </el-row>

      <el-row :gutter="gutter">
        <el-col v-if="step" :span="8">
          <el-form-item label="Reviewer">
            <select-users v-model="step.approved_by" manager />
          </el-form-item>
        </el-col>

        <el-col v-if="step" :span="4">
          <el-form-item label="Review Date" required>
            <el-date-picker value-format="yyyy-MM-dd" :format="dateFormat" v-model="step.approved_at" placeholder="Reviewed"  :disabled="dis"></el-date-picker>
          </el-form-item>
        </el-col>

        <el-col v-if="step" :span="4" :offset="2">
          <el-form-item  label="" >
            <el-switch active-text="Yes" inactive-text="No" active-color="#5ccdcd"
             inactive-color="#cd5c5c"
             v-model="step.approved"
               :disabled="dis"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>

    <files-panel
      v-if="rowData.id"
      type="site"
      :id="rowData.site_id"
      process="progress"
      :process-id="rowData.id"
      :disabled="dis"
      :max-files="20"
       />

 </edit-pane>

</div>
</template>


<script>

import {settings} from '@/components/Data'

import PermitMxins from '@/mixins/PermitMixins'

export default {
  mixins: [PermitMxins],

  props: {
    siteId: {
      type: Number,
      required: true
    },

    rowData: {
      type: Object,
      required: true
    },

    stepData: {
      type: Object,
      required: true
    },

    disabled: {
      type: Boolean,
      default: true
    }
  },

  watch: {
    stepData: function (data) {
      this.stepData = data
    }
  },

  methods: {
    completedDate (date, toggle) {
      if (!date) {
        toggle = true
      } else {
        toggle = false
      }
    },

    completedToggle (date, toggle) {
      if (!toggle) {
        date = new Date()
      } else {
        date = null
      }
//      console.log('completedToggle', date, toggle)
    },

    success (response) {
      this.dis = true
    },


    fail (response) {
      this.dis = true
    },


    onSave () {
      /*
      this.ticket.opened = this.formatDateTimeSql(this.ticket.opened)
      this.ticket.target = this.formatDateTimeSql(this.ticket.target)
      this.ticket.completedDate = this.formatDateTimeSql(this.ticket.completedDate)

      this.ticket.schedStart = this.formatDateTimeSql(this.ticket.schedStart)
      this.ticket.schedNext = this.formatDateTimeSql(this.ticket.schedNext)
      this.ticket.schedLast = this.formatDateTimeSql(this.ticket.schedLast)
      this.ticket.schedEnd = this.formatDateTimeSql(this.ticket.schedEnd)
      */

      if (!this.step.organisation_id) {
//        console.log('step', this.step, 'id', this.step.id, 'org. id', this.step.organisation_id, 'xolas', this.getStore().xolasClient.id)
        this.step.organisation_id =  Number(this.getStore().xolasClient.id)
      }

      this.saveForm(this, '/step', this.step.id, this.step,
        this.step.name,
        this.success,
        this.fail)

    },

    onCancel () {
      this.dis = true
    },

    onEdit () {
      this.dis = false
    },

  },


  data () {
    return {
      gutter: 16,
      dis: this.disabled,
      actionData: this.rowData,
      step: this.stepData,
      doc: this.stepData.state,
      dateFormat: settings.selectDateFormat,
      width: '12px',
      status: [
        {type: 'Pending'},
        {type: 'Rejected'},
        {type: 'Approved'}
      ]
    } // return
  } // data
}

</script>
